/*
  FormattedMessages.js - FormattedMessages for Sent Component
*/

// NPM MODULES
import React from 'react';
import { FormattedMessage } from 'react-intl';

const FormattedMessages = {
  backText: (
    <FormattedMessage
      id="Sent.backText"
      defaultMessage="Back to Scheduled List"
    />
  ),
  cancelPendingMessage: (
    <FormattedMessage
      id="Sent.cancelPendingMessage"
      defaultMessage="Cancel Pending Message"
    />
  ),
  queuedHeader: (
    <FormattedMessage id="Sent.queuedHeader" defaultMessage="Queued" />
  ),
  failedHeader: (
    <FormattedMessage id="Failed.failedHeader" defaultMessage="Failed" />
  ),
  toHeader: <FormattedMessage id="Sent.toHeader" defaultMessage="To" />,
  statusHeader: (
    <FormattedMessage id="Sent.statusHeader" defaultMessage="Status" />
  ),
  errorCodeHeader: (
    <FormattedMessage id="Sent.errorCodeHeader" defaultMessage="Error Code" />
  ),
  errorTextHeader: (
    <FormattedMessage id="Sent.errorTextHeader" defaultMessage="Error Text" />
  ),
  encodingHeader: (
    <FormattedMessage id="Sent.encodingHeader" defaultMessage="Encoding" />
  ),
  messageHeader: (
    <FormattedMessage id="Sent.messageHeader" defaultMessage="Message" />
  ),
  searchButton: (
    <FormattedMessage id="Global.SearchButton" defaultMessage="Search" />
  ),
  clearFilters: (
    <FormattedMessage id="Admin.Clear" defaultMessage="Clear Filters" />
  ),
  dateTimeText: (
    <FormattedMessage
      id="Websms.DeliveryDateTimeText"
      defaultMessage="Delivery Date/Time"
    />
  ),
  scheduledHeader: (
    <FormattedMessage id="Sent.scheduledHeader" defaultMessage="Scheduled" />
  ),
  fromText: <FormattedMessage id="websms.FromText" defaultMessage="From" />,
  name: <FormattedMessage id="Websms.Name" defaultMessage="Name" />,
  searchingText: (
    <FormattedMessage id="App.SearchingText" defaultMessage="Searching..." />
  ),
  messageText: (
    <FormattedMessage id="Websms.MessageText" defaultMessage="Message" />
  ),
  noResult: (
    <FormattedMessage
      id="Reports.NoResult"
      defaultMessage="No results found."></FormattedMessage>
  ),
  filterNote: (
    <FormattedMessage
      id="Websms.filterNoteError"
      defaultMessage="NOTE: Numbers should be entered as only digits, no spaces or
      +."
    />
  ),
  // New formatted messages for Scheduled.jsx
  searchScheduledMessages: (
    <FormattedMessage
      id="Websms.SearchScheduledMessages"
      defaultMessage="Search Scheduled Messages"
    />
  ),
  byField: <FormattedMessage id="Websms.ByField" defaultMessage="By Field:" />,
  subject: <FormattedMessage id="Websms.Subject" defaultMessage="Subject" />,
  to: <FormattedMessage id="Websms.To" defaultMessage="To" />,
  message: <FormattedMessage id="Websms.Message" defaultMessage="Message" />,
  cancelAllPendingMessages: (
    <FormattedMessage
      id="Websms.CancelAllPendingMessages"
      defaultMessage="Cancel All Pending Messages"
    />
  ),
  cancelSelectedPendingMessages: (
    <FormattedMessage
      id="Websms.CancelSelectedPendingMessages"
      defaultMessage="Cancel Selected Pending Messages"
    />
  ),
  cancelConfirmationMessage: (
    <FormattedMessage
      id="Websms.CancelConfirmationMessage"
      defaultMessage="Are you sure you would like to cancel all of your pending messages?"
    />
  ),
  subjectHeader: (
    <FormattedMessage id="Websms.SubjectHeader" defaultMessage="Subject" />
  ),
  recipientCountHeader: (
    <FormattedMessage
      id="Websms.RecipientCountHeader"
      defaultMessage="Recipient Count"
    />
  ),
  pendingCountTooltip: (
    <FormattedMessage
      id="Websms.PendingCountTooltip"
      defaultMessage="Number of pending messages out of the total messages found."
    />
  ),
  messageCountTooltip: (
    <FormattedMessage
      id="Websms.MessageCountTooltip"
      defaultMessage="Number of messages found."
    />
  ),
  found: <FormattedMessage id="Websms.Found" defaultMessage="Found Groups" />,
  foundTooltip: (
    <FormattedMessage
      id="Websms.FoundTooltip"
      defaultMessage="Shows the number of message groups found."
    />
  ),
};

export default FormattedMessages;
